// eslint-disable-next-line
import { ctaConfig, GeneralVehicleData, ctaItems } from './CtaAutomation';
import { ScenarioKeys } from './CtaAutomation.enum';

export const setCtaButtonsFromService = async (
  vehicleData: GeneralVehicleData,
  ctaConfig?: ctaConfig | undefined,
  scenario?: ScenarioKeys,
): Promise<ctaItems | null> => {
  if (vehicleData?.modelSeries && ctaConfig) {
    const { enquiry, informed } = ctaConfig;
    const { modelSeries, subBrands } = vehicleData;
    const { loadCtaConfiguration } = await import('@dh-io-globalelem/vehicle-context-automation');
    const configuration = await loadCtaConfiguration(modelSeries, subBrands, enquiry, informed, scenario);
    if (configuration) {
      const { primary, secondary } = configuration;
      return { primary, secondary };
    }
  }

  return null;
};

export default setCtaButtonsFromService;
